var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdver1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4626 10.7998C10.4626 9.12222 11.8227 7.76221 13.5002 7.76221C15.1777 7.76221 16.5378 9.12222 16.5378 10.7998C16.5378 12.4773 15.1777 13.8373 13.5002 13.8373C11.8227 13.8373 10.4626 12.4773 10.4626 10.7998Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.8002C0 13.0134 0.573706 13.7588 1.72113 15.2495C4.01222 18.2259 7.85459 21.6004 13.5002 21.6004C19.1459 21.6004 22.9882 18.2259 25.2793 15.2495C26.4267 13.7588 27.0005 13.0134 27.0005 10.8002C27.0005 8.58697 26.4267 7.84166 25.2793 6.35096C22.9882 3.37447 19.1459 0 13.5002 0C7.85459 0 4.01222 3.37447 1.72113 6.35096C0.573706 7.84166 0 8.58697 0 10.8002ZM13.5002 5.7376C10.7042 5.7376 8.43765 8.0042 8.43765 10.8002C8.43765 13.5962 10.7042 15.8628 13.5002 15.8628C16.2963 15.8628 18.5628 13.5962 18.5628 10.8002C18.5628 8.0042 16.2963 5.7376 13.5002 5.7376Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdver1);
export default __webpack_public_path__ + "static/media/Adver1.6595eadcdcc940eb59ae3a40dc00e066.svg";
export { ForwardRef as ReactComponent };